/*****************order tracking and cancel starts here**********************/

var ens_link = "https://hulsecure.in/ensenterprises/indulekha/order_cancelled";
var ens_link_ushop = "https://hulsecure.in/ensenterprises/indulekha";
var store = "indulekha";
var storeOTP = "indulekha";
$(document).ready(function () {
  var body_class = $("body").attr("class");
  var html_class = $("html").attr("class");

  /*start order cancel*/
  $("#cancel_order_from").submit(function (event) {
    event.preventDefault();
    var order_id = $("#order_id").val().replace("#", "");
    localStorage.setItem("yourorderid", order_id);
    opt_popup_open();
  });
  /*end order cancel*/
  /* track order function */
  Date.prototype.monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  Date.prototype.getMonthName = function () {
    return this.monthNames[this.getMonth()];
  };
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  $(".track_order_from").click(function () {
    var track_type = $("[name=track_type]:checked").val();
    var order_id = $("[name=track_id]").val();
    order_track(track_type, order_id);
  });
  $('[name="track_type"]').click(function () {
    $("#error_text").text("").hide();
    $("#success_text").text("").hide();
    $('[name="track_id"]').show();
    $("#phone_error").hide();
    var track_type = $("[name=track_type]:checked").val();

    if (track_type == "phone") {
      $(".submit_button").hide();
      $("#get_otp").show();
      $("#get_otp").prop("disabled", false);
    } else {
      $(".submit_button").show();
      $("#get_otp").hide();
      $("#get_otp").prop("disabled", false);
      $("#Otp_value").hide();
      $("#verify_otp").hide();
      $(".resend_otp").hide();
    }
  });
  if (body_class.match("template-account")) {
    var track_type = "phone";
    var order_id = $("#get_user_email").val();
  }
  $(".order_cancel_account").click(function (e) {
    e.preventDefault();
    var phone_no = $(this).attr("data-phone");
    var order_id = $(this).attr("data-orderid").replace("#", "");
    localStorage.setItem("yourorderid", order_id);
    opt_popup_open();
  });
  function opt_popup_open() {
    $(".mobile_verification").show();
    $(".otp_verification").hide();
    $(".otp_cod_verification").css("display", "block");
    $("body").addClass("otp_overlay");
  }
  function order_track(track_type, order_id) {
    $("#result_track").html("");
    $("#success_text").text("").hide();
    $("#error_text").text("").hide();
    $("#cancel_order_from").hide();
    $("#table_for_order_data").hide();

    var url_link =
      ens_link +
      "/shiprocket_api.php?store=" +
      store +
      "&track_type=" +
      track_type +
      "&order_id=" +
      order_id;
    if (order_id != "") {
      axios({
        url: url_link,
        method: "POST",
      })
        .then((resultsuggation) => {
          var result = resultsuggation.data;

          console.log(resultsuggation);
          console.log(result);
          var array_length = result.length;
          if (track_type == "phone") {
            if (array_length <= 0) {
              $("#error_text").text("Data not found").show();
              return false;
            } else {
              var html = "";
              var count = 0;
              $.each(result, function (key, val) {
                var order_name = val.order_name;
                var created_at = val.created_at;
                var payment_method = val.payment_method;
                var fulfillment_status = val.fulfillment_status;
                var track_order = val.track_order;
                var total_price = val.total_price;

                html += "<tr>";
                html +=
                  '<td><a href="' +
                  track_order +
                  '" class="Link Link--underline">' +
                  order_name +
                  "</a></td>";
                html += "<td>" + created_at + "</td>";
                html += "<td>" + payment_method + "</td>";
                html += "<td>" + fulfillment_status + "</td>";
                html += "<td>₹" + total_price + "</td>";
                html +=
                  '<td class="Text--alignRight"><img title="Cancel order" src="https://cdn.shopify.com/s/files/1/0582/0671/6068/files/cancel-order.png?v=1639753581" width="35" height="35"><a href="' +
                  track_order +
                  '"><img title="Track order" src="https://cdn.shopify.com/s/files/1/0582/0671/6068/files/track-order-enabled.png?v=1639753643" width="35" height="35"></a></td>';
                html += "</tr>";
                count = count + 1;
                if (count == array_length) {
                  console.log(html);
                  $("#order_details_tbody").html(html);
                  $("#table_for_order_data").show();
                }
              });

              return false;
            }
          } else {
            if (result == "canceled order") {
              $("#error_text").text("Your order has been cancelled").show();
              var order_id = $("[name=track_id]").val();
              $("#order_id").val(order_id);
            } else if (result == "No fulfilled") {
              $("#success_text")
                .text(
                  "We are working to pack the order. Will keep you updated for the status"
                )
                .show();
              var order_id = $("[name=track_id]").val();
              $("#order_id").val(order_id);
              return false;
            } else if (result == "Order not found") {
              $("#error_text").text("Data not found").show();
              return false;
            }
            var status_code = result["status_code"];
            if (status_code == "404") {
              $("#error_text").text("Data not found").show();
              return false;
            }

            var url_link = result["tracking_data"]["track_url"];
            var etd = result["tracking_data"]["shipment_track"][0]["edd"];
            console.log(etd);
            if (etd == null) {
              etd =
                result["tracking_data"]["shipment_track"][0]["delivered_date"];
            }
            var dateObj = new Date(etd);
            var month = dateObj.getMonthName(); //months from 1-12
            var date = dateObj.getDate();
            if (date < 9) {
              date = "0" + date;
            }
            var year = dateObj.getUTCFullYear();
            var on_time = "(On Time)";
            var day = days[dateObj.getDay()];

            console.log(month);
            console.log(date);
            console.log(day);
            console.log(year);
            $.ajax({
              url: url_link,
              success: function (result) {
                var html_value = $(result)
                  .find(".content.inner_page")
                  .html()
                  .replace(
                    "/post_order/img/available_soon.png",
                    "https://shiprocket.co/post_order/img/available_soon.png"
                  );

                $("#result_track").html(html_value);
                setTimeout(function () {
                  $("#edd_month").text(month);
                  $("#delay_text").text(on_time);
                  $("#edd_day").text(day);
                  $("#edd_date").html(
                    date + '<span class="year_txt">' + year + "</span>"
                  );
                  $(".edd_info").show();
                }, 500);

                $("html, body").animate(
                  {
                    scrollTop: $("#main_cont").offset().top + 300,
                  },
                  800
                );
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      var msg_fill = "Input Field";
      if (track_type == "phone") {
        msg_fill = "Mobile Number";
      } else if (track_type == "order_id") {
        msg_fill = "Order Id";
      } else if (track_type == "awb") {
        msg_fill = "Tracking Number";
      }

      $("#error_text")
        .text("Please Enter " + msg_fill)
        .show();
      console.log("please fill order id");
    }
  }

  $('[name="track_id"]').keyup(function (e) {
    var track_type = $("[name=track_type]:checked").val();
    var phoneNum = $(this).val();
    if (track_type == "phone") {
      var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
      if (!phone_regex.test(phoneNum)) {
        $("#phone_error").show();
        $("#get_otp").prop("disabled", true);
      } else {
        $("#phone_error").hide();
        $("#get_otp").prop("disabled", false);
      }
    }
  });
  $("#get_otp").click(function () {
    $("#error_text").text("").hide();
    $("#success_text").text("").hide();
    var mobNumber = $('[name="track_id"]').val();
    if (mobNumber != "") {
      $("#get_otp").prop("disabled", true);
      send_otp(mobNumber);
    } else {
      $("#error_text").text("Please Enter Phone Number").show();
    }
  });
  function send_otp(mobNumber) {
    $("#error_text").text("").hide();
    $("#success_text").text("").hide();
    var mobUrl = ens_link + "/send_otp.php?mobile_number=" + mobNumber;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        $("#get_otp").prop("disabled", true);
        timer(30);
        $('[name="track_id"]').hide();
        $("#next").hide();
        $("#get_otp").hide();
        $("#Otp_value").show();
        $("#verify_otp").show();
        $(".resend_otp").show();
        $(".resend_otp").show();
        $("#success_text").text("OTP has been sent to your Mobile").show();
      }
    };
    xhttp.open("GET", mobUrl, true);
    xhttp.send();
  }

  $("#verify_otp").click(function () {
    var mobNumber = $('[name="track_id"]').val();
    var otpNumber = $('[name="Otp_value"]').val();

    var mobotpUrl =
      ens_link +
      "/check_otp.php?mobile_no=" +
      mobNumber +
      "&otp_code=" +
      otpNumber;

    console.log(mobotpUrl);
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var json_data = JSON.parse(this.responseText);
        var status = json_data.status;
        var otp_msg = json_data.msg;

        if (status == "success") {
          $("#get_otp").prop("disabled", false);
          $("#next").trigger("click");
          $("#verify_otp").hide();
          $(".resend_otp").hide();
          $("#Otp_value").hide();
          $("#get_otp").show();
          $('[name="track_id"]').show();
        } else {
          $("#success_text").text("").hide();
          $("#error_text").text("Please Enter Correct OTP").show();
        }
      }
    };
    xhttp.open("GET", mobotpUrl, true);
    xhttp.send();
  });

  let countdown;
  function timer(seconds) {
    clearInterval(countdown);
    const now = Date.now();
    const then = now + seconds * 1000;
    displayTimeLeft(seconds);
    countdown = setInterval(() => {
      const secondsLeft = Math.round((then - Date.now()) / 1000);
      if (secondsLeft < 0) {
        clearInterval(countdown);
        $(".resend_button").css("display", "block");
        $(".resend_otp_message").css("display", "none");
        return;
      } else {
        $(".resend_button").css("display", "none");
        $(".resend_otp_message").css("display", "block");
      }
      displayTimeLeft(secondsLeft);
    }, 1000);
  }

  function displayTimeLeft(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainderSeconds = seconds % 60;
    const display = `${minutes}:${
      remainderSeconds < 10 ? "0" : ""
    }${remainderSeconds}`;
    ``;
    var counter = document.getElementById("resendcountdown");

    counter.innerHTML = display;
  }
  $(".resend_button a").click(function () {
    $("#get_otp").trigger("click");
  });
});
function cancel_order(order_id, phone_no, reason_for_canel, otpNumber) {
  $(".ordercanelbutton").prop("disabled", false);
  var ctype = "{{customer.id}}";
  console.log(window.para);
  var ctype = window.para.isCustomer;
  console.log("ctype");
  console.log(ctype);
  $("#error_in_cancel_order").text("").hide();
  $("#success_in_cancel_order").text("").hide();
  var main_link = ens_link + "/order_cancelled.php";

  var url_link =
    main_link +
    "?otpNumber=" +
    otpNumber +
    "&reason=" +
    reason_for_canel +
    "&order_name=" +
    order_id +
    "&ptype=" +
    phone_no +
    "&store_name=" +
    store +
    "&ctype=" +
    ctype;
  console.log(url_link);

  axios({
    url: url_link,
    method: "POST",
  })
    .then((resultsuggation) => {
      $(".loader_cancel").hide();
      console.log(resultsuggation.data);
      if (resultsuggation.data == "error_4") {
        var msg_show = "Your order has been cancelled already!";
        $("#error_in_cancel_order").text(msg_show).show();
      } else if (resultsuggation.data == "Already existed") {
        var msg_show = "Your order cancellation request has been already sent!";
        $("#error_in_cancel_order").text(msg_show).show();
      } else if (resultsuggation.data == "order_not_exist_for_this_user") {
        var msg_show = "This order is not associated with your account!";
        $("#error_in_cancel_order").text(msg_show).show();
      } else if (resultsuggation.data == "error_3") {
        var msg_show = "Your order can't be cancelled as it is in transit.";
        $("#error_in_cancel_order").text(msg_show).show();
      } else if (resultsuggation.data == "error_1") {
        var msg_show = "Phone number is Required";
        $("#error_in_cancel_order").text(msg_show).show();
      } else if (resultsuggation.data == "error_2") {
        var msg_show = "Phone number is not associated with this order";
        $("#error_in_cancel_order").text(msg_show).show();
      } else {
        var msg_show =
          "Your order cancellation request has been sent successfully!";
        $(".ordercanelbutton").prop("disabled", true);
        $("#success_in_cancel_order").text(msg_show).show();
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

/*****************order tracking and cancel ends here**********************/
